import { useRouter } from 'next/router'
import { useEffect } from 'react'

import * as gtm from '@/lib/googleTagManager'
import { useAuthUser } from '@/modules/Auth'

export function usePageView() {
  const router = useRouter()
  const { authUser } = useAuthUser()

  useEffect(() => {
    gtm.pageview(router.asPath, authUser, {
      programId: router.query.programId
        ? Number(router.query.programId)
        : undefined,
      facilityId: router.query.facilityId
        ? Number(router.query.facilityId)
        : undefined,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // useEffect(() => {
  //   const handleRouteChange = (
  //     path: string,
  //     { shallow }: { shallow: boolean },
  //   ) => {
  //     if (shallow) return

  //     gtm.pageview(path, authUser, {
  //       programId: router.query.programId
  //         ? Number(router.query.programId)
  //         : undefined,
  //       facilityId: router.query.facilityId
  //         ? Number(router.query.facilityId)
  //         : undefined,
  //     })
  //   }

  //   router.events.on('routeChangeComplete', handleRouteChange)

  //   return () => {
  //     router.events.off('routeChangeComplete', handleRouteChange)
  //   }
  // }, [router, authUser])
}
